import { useState } from 'react'
import { GoPlus, GoDash } from 'react-icons/go'

const FAQ = ({question, answer}) => {
  const [isAnswerShowing, setIsAnswerShowing] = useState(false);

  
  return (
    <article className="faq" onClick={() => setIsAnswerShowing(prev => !prev)}>
        <div className="faq__container">
            <h4 className="faq__question">{question}</h4>
            <button className="faq__icon">
                {
                  isAnswerShowing ? <GoDash /> : <GoPlus />
                }
            </button>
        </div>
        {isAnswerShowing && <p className="faq__answer">{answer}</p>}
    </article>
  )
}

export default FAQ